import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showHeaderText: false,
  },
  mutations: {
    SET_HEADER_STATE(state, value) {
      state.showHeaderText = value;
    },
  },
  actions: {},
});
